/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import { t } from 'i18next';
import { showSuccess } from '../../app/utils/sweetAlert';
import { showSuccessToast } from '../../app/utils/tostify';
import {
	addCategory,
	changeOrderOfCategory,
	changeOrderOfProduct,
	deleteCategoryData,
	editCategory,
	getFamily,
	getParentCategory,
	getSubCategory
} from '../apis/categoriesAPIs';
interface CategoryState {
	isLoggedIn: boolean;
	loading: boolean;
	error: string;
	categoriesList: Array<any>;
	parentCategoryList: Array<any>;
	modifiedCategoriesList: Array<any>;
	modifiedParentCategoryList: Array<any>;
	subCategoryList: Array<any>;
	modifiedSubCategoryList: Array<any>;
}
const initialState: CategoryState = {
	isLoggedIn: false,
	loading: false,
	error: '',
	categoriesList: [],
	parentCategoryList: [],
	modifiedCategoriesList: [],
	modifiedParentCategoryList: [],
	subCategoryList: [],
	modifiedSubCategoryList: []
};
const categorySlice = createSlice({
	name: 'category',
	initialState,
	reducers: {
		resetAllState(state) {
			state.loading = false;
			state.error = '';
			state.categoriesList = [];
			state.parentCategoryList = [];
			state.modifiedCategoriesList = [];
			state.modifiedParentCategoryList = [];
			state.subCategoryList = [];
			state.modifiedSubCategoryList = [];
		},
		resetParentCategory(state) {
			state.parentCategoryList = [];
			state.modifiedParentCategoryList = [];
		},
		resetSubCategoryList(state) {
			state.subCategoryList = [];
			state.modifiedSubCategoryList = [];
		}
		// tempOTP(state, action: any) {
		// 	state.tempOTP = action.payload;
		// },
	},
	extraReducers: (builder) => {
		builder.addCase(getFamily.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			getFamily.fulfilled,
			(state: CategoryState, action: any) => {
				state.loading = false;
				state.categoriesList = action.payload.data;
				state.modifiedCategoriesList = action.payload.data.map(
					(item: any, index: any) => ({
						id: item.category._id,
						name: item.category.category_name,
						order: index,
						type: 'FAMILY',
						count: item.count,
						sec_lang_name:
							item.category.secondary_language_category_name
					})
				);
			}
		);
		builder.addCase(
			getFamily.rejected,
			(state: CategoryState, action: any) => {
				state.loading = false;
				state.error = action.payload;
			}
		);
		builder.addCase(getParentCategory.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			getParentCategory.fulfilled,
			(state: CategoryState, action: any) => {
				state.loading = false;
				state.parentCategoryList = action.payload.data;
				state.modifiedParentCategoryList = action.payload.data.map(
					(item: any, index: any) => ({
						id: item.category._id,
						name: item.category.category_name,
						order: index,
						type: 'CATEGORY',
						parent_id: item.category.parent_id,
						count: item.count,
						sec_lang_name:
							item.category.secondary_language_category_name
					})
				);
			}
		);
		builder.addCase(
			getParentCategory.rejected,
			(state: CategoryState, action: any) => {
				state.loading = false;
				state.error = action.payload;
			}
		);
		builder.addCase(getSubCategory.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
			state.modifiedSubCategoryList = [];
		});
		builder.addCase(
			getSubCategory.fulfilled,
			(state: CategoryState, action: any) => {
				state.loading = false;
				state.subCategoryList = action.payload.data;
				state.modifiedSubCategoryList = action.payload.data.map(
					(item: any, index: any) => ({
						id: item.category._id,
						name: item.category.category_name,
						order: index,
						type: 'SUBCATEGORY',
						count: item.count,
						sec_lang_name:
							item.category.secondary_language_category_name
					})
				);
			}
		);
		builder.addCase(
			getSubCategory.rejected,
			(state: CategoryState, action: any) => {
				state.loading = false;
				state.error = action.payload;
			}
		);
		builder.addCase(
			changeOrderOfCategory.pending,
			(state: CategoryState) => {
				// state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			changeOrderOfCategory.fulfilled,
			(state: CategoryState, action: any) => {
				// state.loading = false;
				showSuccessToast({ message: t(action?.payload?.message) });
			}
		);
		builder.addCase(
			changeOrderOfCategory.rejected,
			(state: CategoryState, action: any) => {
				// state.loading = false;
				state.error = action.payload;
			}
		);
		builder.addCase(deleteCategoryData.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			deleteCategoryData.fulfilled,
			(state: CategoryState, action: any) => {
				state.loading = false;
				showSuccessToast({ message: t(action?.payload?.message) });
			}
		);
		builder.addCase(
			deleteCategoryData.rejected,
			(state: CategoryState, action: any) => {
				state.loading = false;
				state.error = action.payload;
			}
		);
		builder.addCase(addCategory.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			addCategory.fulfilled,
			(state: CategoryState, action: any) => {
				state.loading = false;
				showSuccessToast({ message: t(action?.payload?.message) });
			}
		);
		builder.addCase(
			addCategory.rejected,
			(state: CategoryState, action: any) => {
				state.loading = false;
				state.error = action.payload;
			}
		);
		builder.addCase(editCategory.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			editCategory.fulfilled,
			(state: CategoryState, action: any) => {
				state.loading = false;
				showSuccess({ message: t(action?.payload?.message) });
			}
		);
		builder.addCase(
			editCategory.rejected,
			(state: CategoryState, action: any) => {
				state.loading = false;
				state.error = action.payload;
			}
		);
		// builder.addCase(getProductofFamily.pending, (state: CategoryState) => {
		//     state.loading = true;
		//     state.error = "";
		// });
		// builder.addCase(getProductofFamily.fulfilled, (state: CategoryState, action: any) => {
		//     state.loading = false;
		//     state.productsList = action.payload.newData
		// });
		// builder.addCase(getProductofFamily.rejected, (state: CategoryState, action: any) => {
		//     state.loading = false;
		//     state.error = action.payload;
		// });
		builder.addCase(
			changeOrderOfProduct.pending,
			(state: CategoryState) => {
				// state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(changeOrderOfProduct.fulfilled, () => {
			// state.loading = false;
			// showSuccessToast({ message: t(action?.payload?.message) })
		});
		builder.addCase(
			changeOrderOfProduct.rejected,
			(state: CategoryState, action: any) => {
				// state.loading = false;
				state.error = action.payload;
			}
		);
	}
});
// export const {
//     // logout,
//     // loginData,
//     // saveDeviceToken,
//     // setSessionExpired,
//     // usingMobile,
//     // currentlyUsing,
//     // tempOTP,
//     // setCurrentUserRole,
//     // updateUserInfo,
//     // updateAccessToken,
//     // updateTokenTime
// } = categorySlice.actions;
export const { resetAllState, resetSubCategoryList, resetParentCategory } =
	categorySlice.actions;
export default categorySlice.reducer;
